
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';


export const fetchpopularArticlesExternal = createAsyncThunk(
  'popularArticlesExternal/fetchPopularArticlesExternal',
  async ({ businessName, group_id }, { rejectWithValue }) => {
    try {
      const url = `${ROOT_URL}/kb/articles/popular/external/${businessName}`;
      const response = await axios.get(url, {
        params: group_id ? { group_id } : undefined,
      });

      // Optional: log the raw response for debugging (remove in production)
      console.log('[fetchpopularArticlesExternal] Raw API response:', response.data);

      return response.data;
    } catch (error) {
      console.error('Error fetching popular articles:', error);
      const message = error.response?.data?.message
        || error.message
        || 'Failed to fetch popular articles';

      return rejectWithValue(message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  articles: [],
};

const popularArticlesExternalSlice = createSlice({
  name: 'popularArticlesExternal',
  initialState,

  reducers: {
    resetPopularArticlesExternal: () => initialState,

    clearPopularError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // ────────────────────────────────────────────────
      // Fetch popular articles
      // ────────────────────────────────────────────────
      .addCase(fetchpopularArticlesExternal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchpopularArticlesExternal.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        // Handle different possible API shapes
        let articlesList = [];

        if (Array.isArray(action.payload)) {
          articlesList = action.payload;
        } else if (action.payload?.data && Array.isArray(action.payload.data)) {
          articlesList = action.payload.data;
        } else if (action.payload?.articles && Array.isArray(action.payload.articles)) {
          articlesList = action.payload.articles;
        }

        console.log('[popularArticlesExternal] Processed articles count:', articlesList.length);

        state.articles = articlesList.map((article) => ({
          ...article,
          id: article._id || article.id,           // support both _id and id
          category:
            article.categoryIds?.[0]?.name ||
            article.category?.name ||
            article.category ||
            '-',
          isFeatured: true,                        // as these are popular/featured in this context
          // You can add more defaults/normalization here if needed
        }));
      })

      .addCase(fetchpopularArticlesExternal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Unknown error';
        state.articles = [];
      })

    // ────────────────────────────────────────────────
    // Optimistic update when an article is un-featured
    // ────────────────────────────────────────────────

  },
});

export const {
  resetPopularArticlesExternal,
  clearPopularError
} = popularArticlesExternalSlice.actions;

export default popularArticlesExternalSlice.reducer;